import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createBooking = (payload) => axios.post(`${API}/bookings`, payload).then((r) => r.data);
export const createContact = (payload) => axios.post(`${API}/contacts`, payload).then((r) => r.data);

const authHeader = (token) => ({ headers: { "X-Admin-Token": token } });

export const verifyAdmin = (token) =>
  axios.post(`${API}/admin/verify`, { token }).then((r) => r.data);

export const listBookings = (token) =>
  axios.get(`${API}/bookings`, authHeader(token)).then((r) => r.data);

export const listContacts = (token) =>
  axios.get(`${API}/contacts`, authHeader(token)).then((r) => r.data);

export const updateBookingStatus = (id, status, token) =>
  axios.patch(`${API}/bookings/${id}`, { status }, authHeader(token)).then((r) => r.data);

export const deleteBooking = (id, token) =>
  axios.delete(`${API}/bookings/${id}`, authHeader(token)).then((r) => r.data);

export const getStats = (token) =>
  axios.get(`${API}/stats`, authHeader(token)).then((r) => r.data);

// Driver applications
export const createDriverApplication = (payload) =>
  axios.post(`${API}/driver-applications`, payload, { maxBodyLength: 10 * 1024 * 1024 }).then((r) => r.data);

export const listDriverApplications = (token) =>
  axios.get(`${API}/driver-applications`, authHeader(token)).then((r) => r.data);

export const updateDriverApplicationStatus = (id, status, token) =>
  axios.patch(`${API}/driver-applications/${id}`, { status }, authHeader(token)).then((r) => r.data);

export const deleteDriverApplication = (id, token) =>
  axios.delete(`${API}/driver-applications/${id}`, authHeader(token)).then((r) => r.data);

// Monitor / Passenger Attendant applications
export const createMonitorApplication = (payload) =>
  axios.post(`${API}/monitor-applications`, payload, { maxBodyLength: 10 * 1024 * 1024 }).then((r) => r.data);

export const listMonitorApplications = (token) =>
  axios.get(`${API}/monitor-applications`, authHeader(token)).then((r) => r.data);

export const updateMonitorApplicationStatus = (id, status, token) =>
  axios.patch(`${API}/monitor-applications/${id}`, { status }, authHeader(token)).then((r) => r.data);

export const deleteMonitorApplication = (id, token) =>
  axios.delete(`${API}/monitor-applications/${id}`, authHeader(token)).then((r) => r.data);
